import QRCode from 'react-qr-code';
import { getToken } from '../utils';
import { toast } from 'react-toastify';

function RefererLinkorCode() {
  const userRefererId = getToken()?.user?.referral_code;

  const referrerLink = `https://apex.loyaltyview.com/${userRefererId}`;

  const handleCopyText = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
    toast.success('Link copied to clipboard');
  };

  return (
    <section className='w-full flex flex-col md:flex-row gap-6 bg-p-wh shadow-lg p-6'>
      <div className='w-full'>
        <h2 className='font-semibold text-[18px] text-p-bk pb-2 mb-6 border-b-hf'>
          Your Referer Code/Link
        </h2>
        <p className='mb-2 text-s-bk'>Referer Id</p>
        <div className='mb-6 items-center justify-between flex border-hf h-12 px-4 rounded'>
          <p>{userRefererId}</p>
          <div
            className='flex flex-row gap-2 items-center text-p-bk cursor-pointer hover:text-b-mc/75 focus:text-b-mc/80'
            onClick={() => handleCopyText(userRefererId)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 512 512'
            >
              <path
                fill='currentColor'
                d='M408 432h-32v32H112V136h32v-32H80v392h328v-64z'
              />
              <path
                fill='currentColor'
                d='M176 16v384h320V153.373L358.627 16Zm288 352H208V48h104v152h152Zm0-200H344V48h1.372L464 166.627Z'
              />
            </svg>
          </div>
        </div>
        <p className='mb-2 text-s-bk'>Referer link</p>
        <div className=' items-center justify-between flex border-hf h-12 px-4 rounded overflow-hidden'>
          <span>{referrerLink}</span>
          <div
            className='flex flex-row gap-2 items-center text-p-bk cursor-pointer hover:text-b-mc/75 focus:text-b-mc/80'
            onClick={() => handleCopyText(referrerLink)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 512 512'
            >
              <path
                fill='currentColor'
                d='M408 432h-32v32H112V136h32v-32H80v392h328v-64z'
              />
              <path
                fill='currentColor'
                d='M176 16v384h320V153.373L358.627 16Zm288 352H208V48h104v152h152Zm0-200H344V48h1.372L464 166.627Z'
              />
            </svg>
          </div>
        </div>
      </div>
      <div className='w-full flex gap-6 flex-col justify-center items-center border-hf py-6'>
        <div className='max-w-[100px]'>
          <QRCode
            size={256}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={referrerLink}
            viewBox={`0 0 256 256`}
          />
        </div>
        <div className='flex '>
          <button
            type='button'
            className='text-p-bk justify-center disabled:text-f-bk hover:bg-f-bk/75 focus:bg-f-bk/80 px-2 md:px-6 mr-6 w-fit py-2 disabled:bg-f-bk bg-f-bk rounded relative'
            onClick={() => handleCopyText(referrerLink)}
          >
            Qr code
          </button>
          <button
            type='button'
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-2 md:px-8 w-ful py-2 disabled:bg-b-mct bg-b-mc rounded relative'
            onClick={() => handleCopyText(referrerLink)}
          >
            Invite Friends
          </button>
        </div>
      </div>
    </section>
  );
}

export default RefererLinkorCode;
